import { DashboardLayout } from "components/DashboardLayout";
import { Header } from "components/DesignSystem/Header/Header";
import { EntitySelector } from "components/EntitySelector/EntitySelector";
import React from "react";
import { FederalRegistrations } from "../../components/FederalRegistration/FederalRegistrations";
import { StateRegistrations } from "components/StateRegistrations/StateRegistrations";
import { usePageTitle } from "hooks/usePageTitle";

export const Registrations = () => {
  usePageTitle("State Compliance");
  return (
    <DashboardLayout
      header={
        <Header
          title="State Compliance"
          v2
          right={
            <div>
              <EntitySelector size="small" showOnlyUSEntities />
            </div>
          }
          className="!t-border-b-0"
          bottom={
            <p className="t-text-body-sm t-text-text-30 t-m-0">
              Standing, deadlines and registrations across every state — in one
              place.
            </p>
          }
        />
      }
    >
      <section className="t-mt-4 t-space-y-8">
        {/* <FederalRegistrations /> */}
        <StateRegistrations />
      </section>
    </DashboardLayout>
  );
};
